import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import FeatureCard from "../Components/FeatureCard";
// import CampCard from "../Components/CampCard";

function VolleyballTryouts() {
  return (
    <>
    <Navbar2 />
    <div className="container-fluid px-0 pb-4 pt-5">
      <div className='h1 text-center'>
          VOLLEYBALL CLUB TRYOUTS
        </div>
          <div className="h4 ms-5 me-5 pb-3 fw-light">
            ADS Volleyball Academy is changing the game in San Antonio with an athlete-first
            approach focused on elite training, real value, and a strong sense of community.
            From first-timers to college-bound players, every athlete gets top-tier coaching,
            unlimited skills clinics, and full support for growth—on and off the court.
            With professional development, and a culture built on
            care, ADS is more than a club—it’s a place to lead, grow, and love the game for
            life. Ready for something better? Join ADS.
          </div>
          <div className="container-fluid pb-5">
          <div className="row g-0">
            <FeatureCard
              backgroundImage="./s3/feature_volleyball_tryouts.jpg"
              title={<>If you are interested in a private club volleyball tryout,<br/>
                please contact Coach Pat at <br/>210-865-4700 <br/>or </>}
              linkUrl='mailto:paltamirano@adssportscomplexcom'
              buttonText="SEND AN EMAIL TO COACH PAT"
              fullWidth
            />
          </div>
        </div>
          <div className="text-center pb-3">
            <a href="/" className="lead" data-bs-toggle="modal" data-bs-target="#ageChartModal">
              Click here for an Age Chart
            </a>
          </div>
        {/* <!-- Modal --> */}
        <div className="modal fade " id="ageChartModal" 
          tabIndex="0" aria-labelledby="ageChartModalLabel" 
          aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content text-center">
              <div className="modal-header m-3">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <img src="/s3/age_chart.png" 
                  alt=""
                  className="img img-fluid"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      <div className="row row-cols-1 row-cols-md-3 row-col-lg-4 g-4">
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>Volleyball Tryouts<br/>Ages 8U-11U</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/registration/init?bid=4587905&redirectToGroupAccReg=true"
              date_time={<>June 12, 2025<br/>
              </>}
              regularPrice={<>Regular $60.00 <div className="h6 text-start pt-3 ps-4">
                    8:30am - 9:00am Registration and Waivers<br/>
                    9:00am - 10:30am Tryout and Evaluation<br/>
                    10:30am - 11:00am Team commitment, contract and deposit requirements
                    </div></>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
        </div> */}
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/vb_tryout1.jpg"
              title={<>Volleyball Tryouts<br/>Ages 12U-13U</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/registration/init?bid=4587907&redirectToGroupAccReg=true"
              date_time={<>June 12, 2025<br/>
              </>}
              regularPrice={<>Regular $60.00 <div className="h6 text-start pt-3 ps-4">
                    12:30pm - 1:00pm: Registration and Waivers<br/>
                    1:00pm - 2:30pm: Tryout and Evaluation<br/>
                    2:30pm - 3:00pm: Team commitment, Contract and Deposit Requirements
                    </div></>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              />
        </div> */}
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/vb_tryout2.jpg"
              title={<>Volleyball Tryouts<br/>Ages 14U-16U</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/registration/init?bid=4587914&redirectToGroupAccReg=true"
              date_time={<>June 13, 2025<br/>
              </>}
              regularPrice={<>Regular $60.00 <div className="h6 text-start pt-3 ps-4">
                    8:30am - 9:00am Registration and Waivers<br/>
                    9:00am - 11:00am Tryout and Evaluation<br/>
                    11:00am - 12:00pm Team commitment, contract and deposit requirements
                    </div></>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              />
        </div> */}
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/vb_tryout1.jpg"
              title={<>Volleyball Tryouts<br/>Ages 17U</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/registration/init?bid=4649018&redirectToGroupAccReg=true"
              date_time={<>July 7, 2025<br/></>}
              regularPrice={<>Regular $60.00 <div className="h6 text-start pt-3 ps-4">
                    6:00pm - 6:30pm: Registration and Waivers<br/>
                    6:30pm - 8:30pm: Tryout and Evaluation<br/>
                    8:30pm - 9:00pm: Team commitment, contract and deposit requirements
                    </div></>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              />
        </div> */}
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/vb_tryout2.jpg"
              title={<>ADS VOLLEYBALL SUPPLEMENTAL TRYOUT DATE</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/registration/init?bid=4587914&redirectToGroupAccReg=true"
              date_time={<>July 19, 2025<br/>
              </>}
              regularPrice={<>Regular $60.00 <div className="h6 text-start pt-3 ps-4">
                    10:00am - 12:00pm 8U-12U<br/>
                    1:00pm - 4:00pm 13U-16U<br/>
                    </div></>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              />
        </div> */}
    </div>
        {/* Uniform Package */}
        <div className="container my-5">
          <h4 className="fw-bold text-center mb-4">Uniform Package</h4>
            <div className="table-responsive">
              <table className="table table-bordered text-start align-middle">
                <thead className="table-success">
                  <tr>
                    <th scope="col">National, Regional</th>
                    <th scope="col">Local</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>3 - Jerseys</td>
                    <td>1 - Jerseys</td>
                  </tr>
                  <tr>
                    <td>3 - Spandex</td>
                    <td>2 - Spandex</td>
                  </tr>
                  <tr>
                    <td>2 - Practice Shirts</td>
                    <td>2 - Practice Shirts</td>
                  </tr>
                  <tr>
                    <td>3 - Pairs of Socks</td>
                    <td>3 - Pairs of Socks</td>
                  </tr>
                  <tr>
                    <td>1 - Pair of Kneepads</td>
                    <td>1 - Pair of Kneepads</td>
                  </tr>
                  <tr>
                    <td>1 - Warmup Top</td>
                    <td>1 - Warmup Top</td>
                  </tr>
                  <tr>
                    <td>1 - Warmup Bottom</td>
                    <td>1 - Warmup Bottom</td>
                  </tr>
                  <tr>
                    <td>1 - Cover Shirt</td>
                    <td>1 - Cover Shirt</td>
                  </tr>
                  <tr>
                    <td>1 - Backpack</td>
                    <td>1 - Backpack</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
        {/* Program Comparison */}
        <div className="container my-5">
          <h4 className="fw-bold text-center mb-4">Program Comparison</h4>
          <div className="table-responsive">
            <table className="table table-bordered text-start align-middle">
              <thead className="table-danger text-white">
                <tr>
                  <th>Detail</th>
                  <th>National Program</th>
                  <th>Regional Program</th>
                  <th>11U–14U Local Program</th>
                  <th>8U–10U Local Program</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Cost</strong></td>
                  <td>$5,200</td>
                  <td>$4,100</td>
                  <td>$1,900</td>
                  <td>$1,625</td>
                </tr>
                <tr>
                  <td><strong>Season Length</strong></td>
                  <td>November–May</td>
                  <td>November–May</td>
                  <td>January-May</td>
                  <td>January-May</td>
                </tr>
                <tr>
                  <td><strong>Practices</strong></td>
                  <td>3x per week (After Spring Break: 2x per week)</td>
                  <td>2x per week</td>
                  <td>2x per week</td>
                  <td>2x per week</td>
                </tr>
                <tr>
                  <td><strong>Tournaments</strong></td>
                  <td>10 incl. 2 out-of-state national qualifiers</td>
                  <td>10 incl. 1 end-of-season qualifier</td>
                  <td>6 local tournaments</td>
                  <td>6 local tournaments</td>
                </tr>
                <tr>
                  <td><strong>Travel Included</strong></td>
                  <td>No</td>
                  <td>No</td>
                  <td>No</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td><strong>Recruiting Support</strong></td>
                  <td>Full Service (video editing, college coach outreach)</td>
                  <td>Full Service (video editing, college coach outreach)</td>
                  <td>None</td>
                  <td>None</td>
                </tr>
                <tr>
                  <td><strong>Strength & Conditioning</strong></td>
                  <td>Included weekly</td>
                  <td>Included weekly</td>
                  <td>Not included</td>
                  <td>Not included</td>
                </tr>
                <tr>
                  <td><strong>Uniform Package</strong></td>
                  <td>Included (see above)</td>
                  <td>Included (see above)</td>
                  <td>Included (see above)</td>
                  <td>Included (see above)</td>
                </tr>
                <tr>
                  <td><strong>Extras</strong></td>
                  <td>Unlimited Clinics</td>
                  <td>Unlimited Clinics</td>
                  <td>Half Off Clinics</td>
                  <td>Half Off Clinics</td>
                </tr>
                <tr>
                  <td><strong>Items NOT Included</strong></td>
                  <td>Lodging, Food, USAV Registration ($45), AAU Fee ($500), Additional Qualifiers ($500), Transportation to/from events</td>
                  <td>Lodging, Food, USAV Registration ($45), AAU Fee ($500), Additional Qualifiers ($500), Transportation to/from events</td>
                  <td>Lodging, Food, USAV Registration ($45), AAU Fee ($500), Additional Qualifiers ($500), Transportation to/from events</td>
                  <td>Lodging, Food, USAV Registration ($45), AAU Fee ($500), Additional Qualifiers ($500), Transportation to/from events</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Payment Overview & Montyly Payment Schedule*/}
        <div className="container my-5">
          <h4 className="fw-bold text-center mb-4">Team Payment Overview</h4>      
          <div className="table-responsive mb-5">
            <table className="table table-bordered text-start align-middle">
              <thead className="table-danger text-white">
                <tr>
                  <th>Detail</th>
                  <th>National Team</th>
                  <th>Regional Team</th>
                  <th>11U–14U Local Team</th>
                  <th>8U–10U Local Team</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Total Amount</strong></td>
                  <td>$5,200.00</td>
                  <td>$4,100.00</td>
                  <td>$1,900.00</td>
                  <td>$1,625.00</td>
                </tr>
                <tr>
                  <td><strong>Deposit</strong></td>
                  <td>$500.00</td>
                  <td>$400.00</td>
                  <td>$150.00</td>
                  <td>$150.00</td>
                </tr>
                <tr>
                  <td><strong>Remaining Balance</strong></td>
                  <td>$4,700.00</td>
                  <td>$3,700.00</td>
                  <td>$1,750.00</td>
                  <td>$1,475.00</td>
                </tr>
                <tr>
                  <td><strong>Monthly Payment</strong></td>
                  <td>$470.00</td>
                  <td>$370.00</td>
                  <td>$350.00</td>
                  <td>$295.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Monthly Payment Schedule */}
          <h5 className="fw-bold text-center mb-4">Monthly Payment Schedule</h5>
          <div className="table-responsive">
            <table className="table table-bordered text-start align-middle">
              <thead className="table-danger text-white">
                <tr>
                  <th>Month</th>
                  <th>National Team</th>
                  <th>Regional Team</th>
                  <th>11U–14U Local Team</th>
                  <th>8U–10U Local Team</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>July 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>August 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>September 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>October 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>November 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>December 1st</td><td>$470.00</td><td>$370.00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>January 1st</td><td>$470.00</td><td>$370.00</td><td>$350.00</td><td>$295.00</td></tr>
                <tr><td>February 1st</td><td>$470.00</td><td>$370.00</td><td>$350.00</td><td>$295.00</td></tr>
                <tr><td>March 1st</td><td>$470.00</td><td>$370.00</td><td>$350.00</td><td>$295.00</td></tr>
                <tr><td>April 1st</td><td>$470.00</td><td>$370.00</td><td>$350.00</td><td>$295.00</td></tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    <Footer />
  </>
);
}

export default VolleyballTryouts;
